import { loadImage } from "../../../helpers/Image.helper";

export function generateStars(width, height) {
	return Promise.all([
		loadImage('effects/star.png'),
	]).then(images => {
		//snowflake particles
		let mp = 15; //max particles
		let particles = [];
		for (var i = 0; i < mp; i++) {
			particles.push({
				x: Math.random() * width, //x-coordinate
				y: Math.random() * height, //y-coordinate
				size: Math.random() * 30, //radius
				d: Math.random() * mp, //density
				rf: Math.random() - .5, // rotation factor
				img: images[Math.floor(Math.random() * images.length)],
			});
		}

		let angle = 0;

		return {
			mp,
			particles,
			draw: (p, ctx) => {
				const rot = (p.size + angle) * p.rf;
				ctx.translate(p.x, p.y);
				ctx.rotate(rot);
				if (p.img) {
					ctx.drawImage(p.img, -(p.size/2), -(p.size/2), p.size, p.size);
				}
				ctx.rotate(-rot);
				ctx.translate(-p.x, -p.y);
			},
			update: () => {
				angle += Math.PI / 60;

				//Function to move the snowflakes
				//angle will be an ongoing incremental flag. Sin and Cos functions will be applied to it to create vertical and horizontal movements of the flakes
				for (var i = 0; i < mp; i++) {
					var p = particles[i];

					let speed = (1 + p.size / 2) * .2;
					p.y += speed;
					p.x -= speed;

					//Sending flakes back from the top when it exits
					//Lets make it a bit more organic and let flakes enter from the left and right also.
					if (p.x > width + 5 || p.x < -5 || p.y > height) {
						if (i % 3 > 0) //66.67% of the flakes
						{
							particles[i] = { ...p, x: Math.random() * width, y: -10 };
						}
						else {
							particles[i] = { ...p, x: width + 5, y: Math.random() * height };
						}
					}
				}
			},
		}
	});
}
